export enum TaskState {
	Waiting   = 'waiting',		// task is waiting to start Executing (though a time condition might prevent it from executing right now)
	Executing = 'executing',
	Success   = 'success',
	Failure   = 'failure',		// task tried to execute but there was a run-time error
	Cancelled = 'cancelled',	// task was cancelled before or during execution
}
